import { Injectable, inject } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { FileDataModel } from '../../cmg-1003/models';
import { PostProcessingUrlaUiService } from '../post.processing.urla.ui.service';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): FileDataModel {
  return <FileDataModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-file-data-store' })
export class Cmg1003FileDataStore extends Store<FileDataModel> implements iStoreActions<FileDataModel> {
  private readonly _postProcessingUrlaUiService = inject(PostProcessingUrlaUiService);

  private _initValue: FileDataModel = null;

  constructor() {
    super(createInitialState());
  }

  akitaPreUpdate = (model: Readonly<FileDataModel>, updatedModel: FileDataModel) => {
    if (model && model.loanProcessorUserName !== updatedModel.loanProcessorUserName) {
      this._postProcessingUrlaUiService.setFormControlHasChanged('loanProcessorUserName');
    }

    return updatedModel;
  };

  preInitialize(fileDataModel: FileDataModel) {
    if (fileDataModel && !fileDataModel?.sandboxOrOriginalLoanFile) {
      fileDataModel.sandboxOrOriginalLoanFile = null;
    }
    this.update(fileDataModel);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
